import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsDogledSizeM from './IconToolsDogled_size_m';

const props: CreateIconArguments = {
  l: IconToolsDogledSizeM,
  m: IconToolsDogledSizeM,
  s: IconToolsDogledSizeM,
  xs: IconToolsDogledSizeM,
  name: 'IconToolsDogled',
  renderType: { l: 'default', m: 'default', s: 'default', xs: 'default' },
  color: 'multiple',
};

export default props;
